import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../api";
import logoIcon from "../assets/Logo.png";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setIsError(false);
    setLoading(true);

    if (!email) {
      setMessage("Email wajib diisi");
      setIsError(true);
      setLoading(false);
      return;
    }

    try {
      const response = await api.post("api/forgot-password", { email });
      setMessage(response.data.message);
      setIsError(false);
      setTimeout(() => navigate("/login"), 2000);
    } catch (error) {
      setMessage(
        error.response?.data?.message ||
        "Terjadi kesalahan saat mengirim permintaan reset password"
      );
      setIsError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      {/* Left branding panel */}
      <div className="auth-left">
        <div className="auth-left-circle auth-left-circle-1" />
        <div className="auth-left-circle auth-left-circle-2" />

        <div className="auth-brand" style={{ position: "relative", zIndex: 1 }}>
          <div className="auth-brand-row"><img src={logoIcon} alt="AiDuNode" className="auth-brand-icon" /><span className="auth-brand-name">AiDuNode</span></div>
          <h2 className="auth-left-title">
            Lupa Password?<br />Tenang, kami bantu! 🔑
          </h2>
          <p className="auth-left-desc">
            Masukkan email yang terdaftar dan kami akan mengirimkan
            link untuk mereset password kamu.
          </p>

          <div className="auth-left-chips">
            <span className="auth-left-chip">🔒 Aman &amp; Terenkripsi</span>
            <span className="auth-left-chip">⚡ Proses Cepat</span>
          </div>
        </div>

        <div className="auth-left-footer">
          © 2026 AiDuNode · Universitas Negeri Malang
        </div>
      </div>

      {/* Right form panel */}
      <div className="auth-right">
        <div className="auth-form-wrap">
          <div className="auth-form-header">
            <h1>Reset Password</h1>
            <p>
              Masukkan email akun kamu dan kami akan mengirimkan link reset
              password ke inbox kamu.
            </p>
          </div>

          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="auth-input-group">
              <label className="auth-input-label">Email Terdaftar</label>
              <input
                className="auth-input"
                type="email"
                placeholder="nama@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-full btn-lg"
              disabled={loading}
            >
              {loading ? "⏳ Mengirim..." : "Kirim Link Reset →"}
            </button>
          </form>

          {message && (
            <div className={`auth-message ${isError ? "error" : "success"}`}>
              {isError ? "⚠️" : "✅"} {message}
            </div>
          )}

          <p className="auth-links">
            Ingat password?{" "}
            <Link to="/login">Kembali ke Login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
